import React from 'react';
import { Box, Wrap, Avatar, SkeletonCircle, Skeleton } from '@chakra-ui/react';
import { useQuery } from '@apollo/client';
import queries from '../../utils/query';

import { createStandaloneToast } from '@chakra-ui/react';

const LayoutLastUpdate = ({ isGrid, Tooltip, viewId }) => {
	const toast = createStandaloneToast();
	const { data, error, loading } = useQuery(queries.GET_RECENT_COMMITS(viewId, 1));
	const [lastUpdate, setLastUpdate] = React.useState({
		userName: '',
		lastModified: '',
		userImg: '',
	});

	React.useEffect(() => {
		if (error) {
			toast({
				title: `Ocorreu um erro ao buscar recent commits: ${error}`,
				status: 'error',
				duration: 10000,
				isClosable: true,
				position: 'top',
			});
		}
	}, [error]);

	React.useEffect(() => {
		if (data && data.recentCommits && data.recentCommits.length) {
			const now = new Date();
			const newLastUpdate = { ...lastUpdate };
			const commitDate = new Date(Number(data.recentCommits[0].commitDate));
			let diff = now.getTime() - commitDate.getTime();
			let text = '';
			const userName = data.recentCommits[0].userName;
			diff = diff / 1000;
			if (diff < 60) {
				text = '1 minuto';
			} else if (diff < 3600) {
				text = Math.floor(diff / (60 * 1000)) + ' minutos';
			} else if (diff < 86400) {
				text = Math.floor(diff / 3600) + ' horas';
			} else {
				const val = Math.floor(diff / (3600 * 24));
				text = val == 1 ? '1 dia' : val + ' dias';
			}
			newLastUpdate.lastModified = `Editado há ${text} atrás por ${userName}`;
			newLastUpdate.userImg = 'https://via.placeholder.com/50x50';
			newLastUpdate.userName = userName;
			setLastUpdate(newLastUpdate);
		}
	}, [data]);

	return (
		<Box d="flex" isTruncated flexBasis={'18%'} alignItems="center" mt={isGrid ? 3 : 0}>
			<Wrap mr={1}>
				<SkeletonCircle p={0} size={'6'} m={0} isLoaded={!loading}>
					{lastUpdate.userImg && <Avatar size="xs" name={lastUpdate.userName} src={lastUpdate.userImg} />}
				</SkeletonCircle>
			</Wrap>
			<Box whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" color="gray.500" fontSize="xs" as="span">
				{loading && !lastUpdate.lastModified ? (
					<Skeleton h={'10px'} w={'300px'} />
				) : (
					<Tooltip
						fontSize="xs"
						padding={1}
						hasArrow
						label={lastUpdate.lastModified}
						aria-label="Tooltip de quem editou"
					>
						{lastUpdate.lastModified}
					</Tooltip>
				)}
			</Box>
		</Box>
	);
};

export default LayoutLastUpdate;
